export default "__VITE_ASSET__BgG440ck__"